import React from 'react';
import { BrowserRouter, Redirect, Route, RouteProps, Switch } from 'react-router-dom';
import AgendamentoPresencial from './Pages/AgendamentoPresencial';

import AgendamentoVirtual from './Pages/AgendamentoVirtual';
import AreaMonitor from './Pages/AreaMonitor';
import Home from './Pages/Home';
//import Home from './Pages/Home';
import Login from './Pages/Login';
import Relatorio from './Pages/Relatorio';
import SessoesPresenciais from './Pages/SessoesPresenciais';
import SessoesVirtuais from './Pages/SessoesVirtuais';
import { isAuthenticated } from './Services/ApiService';


export function PrivateRoute({...routeProps}: RouteProps) {
  if(isAuthenticated()) {
    return <Route {...routeProps} />;
  } else {
    return <Redirect to={{ pathname: '/login' }} />;
  }
};

const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Home}></Route>
        <Route exact path="/AgendamentoPresencial" component={AgendamentoPresencial}></Route>
        <Route exact path="/AgendamentoVirtual" component={AgendamentoVirtual}></Route>
        <Route exact path="/Login" component={Login}></Route>
        <PrivateRoute exact path="/AreaDoMonitor" component={AreaMonitor}></PrivateRoute>
        <PrivateRoute exact path="/AreaDoMonitor/SessoesPresenciais" component={SessoesPresenciais}></PrivateRoute>
        <PrivateRoute exact path="/AreaDoMonitor/SessoesVirtuais" component={SessoesVirtuais}></PrivateRoute>
        <PrivateRoute exact path="/AreaDoMonitor/Relatorio" component={Relatorio}></PrivateRoute>

      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
